// extracted by mini-css-extract-plugin
export default {"header":"apps_header__P-GpV","search":"apps_search__-oJuY","pagination":"apps_pagination__0bn3G","spin":"apps_spin__RUXy0"};